// WS 1227508. What a contract-send dispatch actually meant, as a pure decision so it can be
// tested without mounting the PDF pipeline.
//
// Two ways a failed send used to reach the rep as silence:
//
//   1. signTemplate is dispatched WITHOUT .unwrap(), and a rejected createAsyncThunk RESOLVES
//      the dispatch promise. So a 400 never reached the surrounding catch — the same shape
//      already guarded against in BankAccount/SignContract.jsx.
//   2. The success branch had no `else`. A 200 carrying no filePath produced no toast at all,
//      which is indistinguishable from a send that worked.
//
// Both end in "rep clicks Send, sees nothing, modal stays open" — the Linda Pattillo symptom
// one layer up from the original bug.

const GENERIC_FAILURE = 'The document was not sent. Please try again, or contact support if it keeps failing.'

export const resolveSendOutcome = (response) => {
  // A rejected thunk: `error` is set and `payload` carries whatever rejectWithValue was given.
  if (response?.error) {
    return {
      ok: false,
      message: typeof response.payload === 'string' && response.payload.trim()
        ? response.payload
        : GENERIC_FAILURE,
    }
  }

  const filePath = response?.payload?.data?.filePath

  if (typeof filePath === 'string' && filePath.length > 0) {
    return { ok: true, message: 'The document has been successfully sent' }
  }

  // Resolved, but nothing was created. Never silent.
  return { ok: false, message: GENERIC_FAILURE }
}

export default resolveSendOutcome
